<script>
    import Section from "../controls/Section.svelte";
    import GameListing from "../views/GameListing.svelte";
  
    // Example games data
    let games = [
      { id: 1, name: "App 1", image: "/images/app1.jpg" },
      { id: 2, name: "App 2", image: "/images/app2.jpg" },
      { id: 3, name: "App 3", image: "/images/app3.jpg" },
      { id: 4, name: "App 4", image: "/images/app4.jpg" },
    ];
</script>

<div class="space-y-8 text-left">
    <Section title="Add Game" subtitle="Choose the Game you want to add from the list below. You can add multiple games and even have multiple of the same game set up.">
        <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 mt-4">
        {#each games as game (game.id)}
            <GameListing name={game.name} image={game.image} />
        {/each}
        </div>
    </Section>
</div>
